module.exports = __webpack_public_path__ + "static/media/importFlybook3.e89dcfdf.png";